"use client";

import "@/components/home/spectrum-hero.css";
import "@/components/home/site-nav.css";
import { MarketingNav } from "@/components/home/marketing-nav";

import { useSession } from "@/lib/auth/client";

import { memo } from "react";

/**
 * The marketing nav in its page-gutter shell — what every non-hero marketing
 * page mounts. The row itself is MarketingNav, the same one the landing hero
 * renders twice.
 */
export const SiteNav = memo(function SiteNav() {
    const { data: session } = useSession();
    const isAuthenticated = !!session?.user;

    return (
        <div className="dw-site-nav" data-component="SiteNav" data-location="src/components/home/site-nav.tsx">
            <MarketingNav className="dw-home-spectrum-hero__nav" isAuthenticated={isAuthenticated} priority />
        </div>
    );
});
